import Link from 'next/link';

import Button from '@gds/Button/Button';

import { ButtonProps } from '@gds/Button/Button.types';

import { CtaContent } from './Cta.entity';

const Cta = ({ cta, ...restProps }: { cta: CtaContent | string } & ButtonProps) => {
  if (typeof cta === 'string' || !cta || !cta?.link || !cta?.ctaText) return null;
  return (
    <Button
      href={cta.link}
      {...(cta?.darkMode[0]?.codename && {
        darkMode: true,
      })}
      {...restProps}
      Component={Link}
      {...(cta?.color &&
        cta?.color[0]?.codename && {
          color: cta?.color[0]?.codename,
        })}
      {...(cta?.variant &&
        cta?.variant[0]?.codename && {
          variant: cta?.variant[0]?.codename,
        })}
    >
      {cta.ctaText}
    </Button>
  );
};

export default Cta;
